var _ellipse, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalright(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5498 14.5156C17.5498 17.5742 18.3584 20.0527 20.0898 22.2061H21.7598C20.4941 20.7295 19.501 17.3984 19.501 14.5068C19.501 11.6152 20.4941 8.29297 21.7598 6.81641H20.0898C18.3584 8.96094 17.5498 11.4395 17.5498 14.5156Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4502 14.5156C37.4502 17.5742 36.6416 20.0527 34.9102 22.2061H33.2402C34.5059 20.7295 35.499 17.3984 35.499 14.5068C35.499 11.6152 34.5059 8.29297 33.2402 6.81641H34.9102C36.6416 8.96094 37.4502 11.4395 37.4502 14.5156Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2637 20.71C30.1816 20.71 32.168 19.1719 32.6514 16.5527H30.6914C30.2959 18.082 29.0391 18.9873 27.2725 18.9873C24.9434 18.9873 23.4668 17.1152 23.4668 14.1533C23.4668 11.2178 24.9609 9.32812 27.2637 9.32812C28.9863 9.32812 30.3398 10.3916 30.6914 12.0176H32.6426C32.3086 9.37207 30.1377 7.60547 27.2637 7.60547C23.7217 7.60547 21.4541 10.1367 21.4541 14.1533C21.4541 18.1963 23.7041 20.71 27.2637 20.71Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04785 19.5H8.65137V9.79688H5.04785V19.5ZM6.84961 9.26074C7.86914 9.26074 8.64258 8.52246 8.64258 7.55566C8.64258 6.58887 7.86914 5.85059 6.84961 5.85059C5.83008 5.85059 5.05664 6.58887 5.05664 7.55566C5.05664 8.52246 5.83008 9.26074 6.84961 9.26074ZM19.7256 9.79688H15.9551L14.5928 16.5908H14.5225L13.1162 9.79688H9.23145L12.3867 19.5H16.6143L19.7256 9.79688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalright);
export default __webpack_public_path__ + "static/media/legalright.e9ef3f4730dcca92834f0bae8f6fdbcd.svg";
export { ForwardRef as ReactComponent };